import { WithSubpages } from '../../subpages';
import { accountsManagementSubpages } from '../../subpages/dictionary';
import { MAIN_PAGE_PATH } from './paths';
import { PAGE_TITLE } from '../../consts';

const ACCOUNT_MANAGEMENT = () => (
  <WithSubpages mainPagePath={MAIN_PAGE_PATH} title={PAGE_TITLE.USER_MANAGEMENT} items={accountsManagementSubpages} />
);
export default ACCOUNT_MANAGEMENT;
